'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'joystick';
var width = 448;
var height = 512;
var aliases = [128377];
var unicode = 'f8c5';
var svgPathData = 'M224 0c61.9 0 112 50.1 112 112 0 59.2-45.9 107.6-104 111.7l0 128.3 216 0 0 160-448 0 0-160 216 0 0-128.3C157.9 219.6 112 171.2 112 112 112 50.1 162.1 0 224 0zM16 496l416 0 0-128-416 0 0 128zM224 16a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm-16 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJoystick = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;